<div class="okta-callback">
  <p-progressSpinner strokeWidth="3" styleClass="okta-callback__spinner"></p-progressSpinner>
  <p class="okta-callback__label">{{ 'auth.signing_you_in' | translate }}</p>
</div>
